// Transport state only. The backend is the sole operating-mode resolver.
// No persistence and no presentation/business-policy consumers in Phase 1.
export function operatingProfileState(user, loading, requestFailed = false) {
  if (loading && user === null) return { status: "loading", context: null };
  if (!user) return { status: requestFailed ? "error" : "unavailable", context: null };
  const context = user.operating_context;
  const valid = context && context.org_id === user.org_id &&
    context.org_id && ["legacy", "explicit", "invalid"].includes(context.source) &&
    ["CIVIL_CONSTRUCTION", "TRADES_SERVICES"].includes(context.mode);
  // Missing transport (e.g. an older session issuer) is NOT a legacy Civil result.
  return { status: requestFailed ? "error" : valid ? "ready" : "unavailable",
    context: valid ? context : null };
}
